<div>
    <span>
      Nakreslete uzavřený obvod stavby. Lokalizace stavby bude sloužit pro zacílení nabídky dotčených orgánu na místo stavby.<br>
      Kreslení ukončíte (obvod uzavřete) kliknutím na první bod.
    </span>

  <map-editor (changed)="polygonChanged($event)"></map-editor>
</div>
